import { SortDirection } from "@renta-apps/athenaeum-toolkit";
import Localizer from "@/localization/Localizer";
import { pageData } from "@/helpers/CypressHelper";
import DeviceGridHelper from "@/helpers/DeviceGridHelper";
import {Method} from "cypress/types/net-stubbing";

describe('Desktop - Fleet Monitoring - Filters tests', () => {
    before(() => {
        cy.clearAllLocalStorage()
    });

    beforeEach(() => {
        cy.session(['construction_site_role_session'], () => {
            cy.loginAndSelectCompanyRole("cs.user@domain.fi", "ConstructionSite1");
        });
    });

    it('should display view controls', () => {
        const {routes: {getDevicesPagedList}} = pageData().fleetMonitoring;
        cy.intercept(getDevicesPagedList.method as Method, getDevicesPagedList.path, { fixture: 'fleetGetDevicesPagedList.json' });

        cy.intercept('POST', 'api/ConstructionSites/GetConstructionSiteDetails', { fixture: 'constructionSiteDetails.json' });

        cy.visit('/fleet-monitoring');

        DeviceGridHelper.getViewControl()
            .should('exist');

        // The filter has five visible elements.
        DeviceGridHelper.getViewControl()
            .children('div')
            .filter(':visible')
            .should('have.length', 3);

        DeviceGridHelper.getDropdown("filter-by-construction-site-dropdown")
            .get('[data-cy="dropdownLabel"]')
            .should('contain.text', Localizer.fleetMonitoringPageFiltersLabelsConstructionSite);
    });

    it('should set input fields with the values obtain from URL', () => {
        const {routes: {getDevicesPagedList}, filters} = pageData().fleetMonitoring;
        cy.intercept(getDevicesPagedList.method as Method, getDevicesPagedList.path, req => {
            if (req.body.productGroups.length > 0) {
                req.alias = 'postRequestFiltered';
            }
            req.reply({fixture: 'fleetGetDevicesPagedListEmpty.json'});
        });

        cy.visit(`/fleet-monitoring?sortBy=AlertsCount&sortOrder=Asc&productGroups=${JSON.stringify([{name:'Vaihtolava 10m (77664)', id:'77664'}])}`);

        cy.wait('@postRequestFiltered').then(({request}) => {
            DeviceGridHelper.checkDropdownValue("filter-by-product-group-dropdown", Localizer.get(Localizer.componentDropdownMultipleSelectedLanguageItemName, 1));

            filters.sortByFilter.title()
                .should('have.text', Localizer.fleetMonitoringPageFiltersSortByAlerts);

            filters.sortOrderFilter.title()
                .should('have.text', Localizer.enumSortDirectionAsc);

            DeviceGridHelper.checkTags(['Vaihtolava 10m (77664)']);

            // Assert that the request body contains the changed value
            expect(request.body).to.have.property('productGroups')
            expect(request.body.productGroups).to.have.length(1);
            expect(request.body.productGroups[0].name).to.equal('Vaihtolava 10m (77664)');
            expect(request.body.productGroups[0].id).to.equal('77664');
            expect(request.body).to.have.property('sortColumnName', 'AlertsCount');
            expect(request.body).to.have.property('sortDirection', SortDirection.Asc);
        });
    });
});